// Angular 2

import "angular";

import "@angular/core";
import "@angular/common";
import "@angular/compiler";
import "@angular/platform-browser";
import '@angular/animations';
import '@angular/animations/browser';
import '@angular/platform-browser/animations';

import "@angular/platform-browser-dynamic";
import "@angular/http";
import "@angular/router";
import "@angular/forms";
import "@angular/upgrade";
import "@angular/upgrade/static";
import "@angular/material";
import "@angular/material/dialog";
import "@angular/flex-layout";

import "@uirouter/angular/_bundles/ui-router-ng2.js";

import 'rxjs';
import '@angularclass/hmr';

import 'ng2-webstorage';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...

// Angular 1
import "jquery";

import "angular-resource";
import "angular-animate";
import "angular-aria";

import "angular-ui-router/release/angular-ui-router.js";

import "./app/breeze-client-odata-fix";

import "datajs";
import 'breeze-client';

import "breeze-client/breeze.bridge.angular.js";

// 3rd party Angular 1 modules
import "angular-filter/dist/angular-filter.js";
import "angular-loading-bar/build/loading-bar.min.js";

// Material Design
import "angular-material";


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/vendor.ts